module.exports = __webpack_public_path__ + "static/img/coupon.2ed57771.svg";